export const ToggleSidebar = () => ({
  type: "TOGGLE_SIDEBAR",
});

export const toggleColorChart = (command) => ({
  type: "TOGGLE_COLOR_CHART",
  payload: command,
});

export const toggleAlert = (config) => ({
  type: "TOGGLE_ALERT",
  payload: config,
});
